import cronVuetify from "@vue-js-cron/vuetify";
import "@vue-js-cron/vuetify/dist/vuetify.css";

export default cronVuetify;
